<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12 mb-3>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700">USER</h2>
        <v-breadcrumbs class="px-0" :items="breadcrumbs"></v-breadcrumbs>
      </v-flex>
      <v-card>
        <v-card-title>
          <v-flex xs9> User List </v-flex>
          <v-flex xs3 class="text-right">
            <v-icon id="refresh" @click="getData()">refresh</v-icon>
          </v-flex>
          <v-flex xs4 class="my-5">
            <v-text-field
              id="search"
              v-model="search"
              append-icon="search"
              placeholder="Search by email"
              single-line
              hide-details
              @keyup="searchUser()"
            ></v-text-field>
          </v-flex>
          <v-flex
            xs8
            class="text-right"
            v-if="hasPermission('create_user', 'create')"
          >
            <v-btn
              id="add-user"
              depressed
              color="secondblue"
              class="white--text"
              :to="{ name: 'userCreate' }"
            >
              <v-icon left dark>add</v-icon>
              Add new user
            </v-btn>
          </v-flex>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          :must-sort="true"
          :loading="loading"
          :options.sync="options"
          :server-items-length="totalItems"
          :sort-desc.sync="descending"
          :footer-props="{
            itemsPerPageOptions: [5, 10, 15, 25]
          }"
        >
          <v-progress-linear
            slot="progress"
            color="primary"
            indeterminate
          ></v-progress-linear>
          <!-- <template v-slot:item.is_admin="{ item }">
            <v-icon v-if="item.is_admin" color="green">done</v-icon>
            <v-icon v-else>close</v-icon>
          </template> -->
          <template v-slot:item.created_by="{ item }">
            <span v-if="item.logCreate">
              {{
                item.logCreate.length > 0 ? item.logCreate[0].user.email : '-'
              }}
            </span>
            <span v-else>
              {{ '-' }}
            </span>
          </template>
          <template v-slot:item.updated_by="{ item }">
            <span v-if="item.logUpdate">
              {{
                item.logUpdate.length > 0 ? item.logUpdate[0].user.email : '-'
              }}
            </span>
            <span v-else>
              {{ '-' }}
            </span>
          </template>
          <template v-slot:item.status="{ item }">
            {{ item.active ? 'Active' : 'Not Active' }}
          </template>
          <template v-slot:item.activeUser="{ item }">
            <v-btn icon @click="confirmUpdate(item)">
              <v-icon class="icon-toggle" color="secondblue" v-if="item.active"
                >mdi-toggle-switch</v-icon
              >
              <v-icon class="icon-toggle" color="grey" v-else
                >mdi-toggle-switch-off</v-icon
              >
            </v-btn>
          </template>
          <template v-slot:item.loginOptima="{ item }">
            <v-btn icon @click="updateUser(item)">
              <v-icon
                class="icon-toggle"
                color="secondblue"
                v-if="item.is_login_optima"
                >mdi-toggle-switch
              </v-icon>
              <v-icon class="icon-toggle" color="grey" v-else
                >mdi-toggle-switch-off</v-icon
              >
            </v-btn>
          </template>
          <template v-slot:item.userLogin="{ item }">
            {{ item.userLogin ? item.userLogin.last_login : '-' }}
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn
              icon
              :id="'btn-detail' + item.id"
              @click="toDetail(item.id)"
              v-if="hasPermission('view_user', 'view')"
            >
              <v-icon color="green">remove_red_eye</v-icon>
            </v-btn>
            <v-btn
              icon
              :id="'btn-edit' + item.id"
              @click="toEdit(item.id)"
              v-if="hasPermission('edit_user', 'update')"
            >
              <v-icon color="secondblue">mdi-square-edit-outline</v-icon>
            </v-btn>
          </template>
          <template v-slot:no-data>
            <label color="primary">No data displayed</label>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import ProgressDialog from '../../../components/progress_dialog';
import ACLMixin from '../../../mixins/ACLMixin';
import paginationMixin from '../../../mixins/paginationMixin';

export default {
  components: { 'progress-dialog': ProgressDialog },
  mixins: [ACLMixin, paginationMixin],
  data() {
    return {
      progressDialogLoading: true,
      loading: true,
      search: '',
      isSearch: false,
      items: [],
      descending: true,
      sort: '',
      totalItems: 0,
      options: {},
      breadcrumbs: [
        {
          text: 'User Management',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'User List',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      page: 1,
      pageCount: 0,
      itemsPerPage: 5,
      headers: [
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Email',
          value: 'email',
          sortable: false
        },
        {
          text: 'Status',
          value: 'status',
          sortable: false
        },
        {
          text: 'Active',
          value: 'activeUser',
          align: 'left',
          sortable: false
        },
        {
          text: 'Login With Optima',
          value: 'loginOptima',
          align: 'left',
          sortable: false
        },
        {
          text: 'Created At',
          value: 'created_at',
          sortable: false
        },
        {
          text: 'Created By',
          value: 'created_by',
          sortable: false
        },
        {
          text: 'Updated At',
          value: 'updated_at',
          sortable: false
        },
        {
          text: 'Updated By',
          value: 'updated_by',
          sortable: false
        },
        {
          text: 'Last Login',
          value: 'userLogin',
          sortable: false
        },
        {
          text: 'Action',
          value: 'action',
          align: 'center',
          sortable: false
        }
      ],
      timeout: null,
      user: {}
    };
  },
  mounted() {
    // setTimeout(() => {
    //   this.progressDialogLoading = false;
    //   this.loading = false;
    // }, 3000);
    this.getData();
  },
  watch: {
    descending() {
      this.getData();
    }
    // 'search'(value) {
    //   this.getData();
    // }
  },
  methods: {
    searchUser() {
      this.isSearch = true;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.getData();
      }, 900);
    },
    getData() {
      this.progressDialogLoading = true;
      this.loading = true;

      if (this.descending) {
        this.sort = 'desc';
      } else {
        this.sort = 'asc';
      }
      const sort = this.sort;
      let { page, itemsPerPage } = this.options;
      if (this.isSearch) {
        page = 1;
      }
      const search = {
        email: this.search
      };
      // const name = this.search;
      return this.$store
        .dispatch('auth/getAll', {
          page,
          sort,
          limit: itemsPerPage,
          search
        })
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          this.isSearch = false;
          if (data.code === 200) {
            this.items = data.data.result;
            this.totalItems = data.data.total_data;
            page = data.data.pagination.current_page;
            itemsPerPage = data.data.pagination.per_page;
            this.options = { page, itemsPerPage };
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        });
    },
    toEdit(value) {
      this.$router.push({
        params: { id: value },
        name: 'userEdit'
      });
    },
    toDetail(value) {
      this.$router.push({
        params: { id: value },
        name: 'userDetail'
      });
    },
    confirmUpdate(item) {
      this.user = item;
      Swal.fire({
        title: '',
        html: `Are you sure want to ${
          item.active ? 'disable' : 'activate'
        } user <b>${item.email}</b>?`,
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(result => {
        if (result.value) {
          this.updateStatus();
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire('Cancelled', 'Update status cancelled', 'error');
        }
      });
    },
    updateUser(item) {
      this.user = item;
      Swal.fire({
        title: '',
        html: `Are you sure want to allow user <b>${item.email}</b> to login with Optima?`,
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then(result => {
        if (result.value) {
          let param = {
            nik: item.nik,
            name: item.name,
            email: item.email,
            profileIds: item.profiles.map(element => element.id),
            is_login_optima: this.user.is_login_optima ? false : true
          };
          this.$store
            .dispatch('auth/update', { id: item.id, params: param })
            .then(data => {
              this.progressDialogLoading = false;
              this.loading = false;
              if (data.code === 200) {
                Swal.fire('Success!', data.message.text_en, 'success');
                this.getData();
              } else {
                Swal.fire(
                  'Failed!',
                  data.response.data.message.text_en,
                  'error'
                );
              }
            })
            .catch(err => {
              Swal.fire('Failed!', err.response.data.message.text_en, 'error');
              this.progressDialogLoading = false;
              this.loading = false;
            });
        }
      });
    },
    updateStatus() {
      this.progressDialogLoading = true;
      let param = {
        active: this.user.active ? false : true
      };
      this.$store
        .dispatch('auth/updateStatus', { id: this.user.id, paramUser: param })
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            Swal.fire('Success!', data.message.text_en, 'success');
            this.getData();
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    }
  }
};
</script>
<style>
.v-icon.v-icon.icon-toggle {
  font-size: 45px !important;
}
</style>
